import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  InputSignal,
  model,
  ModelSignal,
  signal,
  WritableSignal
} from '@angular/core';



@Component({
  selector: 'app-assembly-frame',
  standalone: true,
  imports: [],
  templateUrl: './assembly-frame.component.html',
  styles:  ":host{ @apply absolute -translate-x-1/2 z-10 min-w-4; }",
})
export class AssemblyFrameComponent {
  private elementRef: ElementRef = inject(ElementRef);
  private REINFORCEMENT_MESSAGE_TIME = 5000;

  /**
   * Input model of frame span component, store creates this object on parent component
   * initialized with default values
   */
  public assemblyFrameValues: ModelSignal<any> = model()

  /**
   * element position relative to the parent element
   */
  public relativePosition: InputSignal<number> = input(0);

  public hasFrame: InputSignal<any> = input<any>();

  /**
   * flag that shows the reinforcement added info message below custom element
   * @protected
   */
  protected showReinforcementAddedMessage: WritableSignal<boolean> = signal(false);

  /**
   * timeout id for clearing the reinforcement added message provided only when reinforcement is added
   * @private
   */
  private clearInfoTimeoutId: number;

  constructor() {
    this.setElementPosition();
    this.showReinforcementAddedMessageInfo();
  }

  /**
   * span value of the space between the frames by dragging the span
   */
  protected dragHandling(){
    const drag = (event: MouseEvent) => {
      const { clientX } = event;
      //this.frameStore.setAdjacentItems(this.assemblyFrameValues().id, this.assemblyFrameValues().index, clientX, this.elementRef.nativeElement);
    }

    //self removal of event listeners
    const stopDrag = () => {
      //window.removeEventListener('mousemove', drag);
      //window.removeEventListener('mouseup', stopDrag);
    }

    //window.addEventListener('mousemove', drag);
    //window.addEventListener('mouseup', stopDrag);
  }

  /**
   * Set the position of the element in the parent element
   * @private
   */
  private setElementPosition(){
    effect(() => {
      this.elementRef.nativeElement.style.left = Math.min(
          Math.max( this.elementRef.nativeElement.clientWidth / 2 , this.relativePosition()),
          this.elementRef.nativeElement.parentElement.clientWidth - this.elementRef.nativeElement.clientWidth / 2
      ) + 'px';
    });
  }

  /**
   * Show reinforcement added message for 5 seconds
   * @private
   */
  private showReinforcementAddedMessageInfo(){
    /*
    effect(() => {

      if(!this.assemblyFrameValues().hasReinforcement()) {

        //toggle flag if reinforcement is toggled to false while message is around
        if( this.showReinforcementAddedMessage()){
          this.showReinforcementAddedMessage.set(false);
          clearTimeout(this.clearInfoTimeoutId);
        }

        return
      }

      this.showReinforcementAddedMessage.set(true);

      //set signal to false after 5 second
      new Promise((resolve) =>{
        this.clearInfoTimeoutId = setTimeout(() => {this.showReinforcementAddedMessage.set(false); resolve(undefined)}, this.REINFORCEMENT_TIME) as any as number;
      });

    });
    */
  }

}
